const ROUTES_WITHOUT_LAYOUT = ['login', 'password.reset', 'password.change'];

/**
 * Whether the authenticated app chrome (topbar / sidebar / breadcrumbs)
 * should render for a route. Gated password flows use the login shell.
 *
 * @param {string} [routeName]
 * @returns {boolean}
 */
export function shouldShowAppLayout(routeName) {
    if (ROUTES_WITHOUT_LAYOUT.includes(routeName)) {
        return false;
    }

    return true;
}
